import classNames from 'classnames';
import React, { useCallback } from 'react';
import UDPerPage from 'ud-ui/components/per-page';
import UDSearchInput from 'ud-ui/components/search';

export interface UDPagedListToolbarProps {
  /** Что набрано в поле прямо сейчас (черновик, до дебаунса). */
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  /** Ввод ещё не доехал до запроса: лупа сменяется спиннером. */
  isSearchLoading?: boolean;
  perPage: number;
  onPerPageChange: (perPage: number) => void;
  /** Дополнительные фильтры страницы — год, спорт, сортировка. */
  extraFilters?: React.ReactNode;
  className?: string;
}

/**
 * Верхняя панель списка: поиск, фильтры страницы, размер страницы.
 *
 * Индикатор загрузки живёт **в поле поиска**, а не поверх выдачи: так видно,
 * что запрос вызван вводом, и список при этом остаётся на экране.
 */
const UDPagedListToolbar = ({
  search,
  onSearchChange,
  searchPlaceholder,
  isSearchLoading,
  perPage,
  onPerPageChange,
  extraFilters,
  className,
}: UDPagedListToolbarProps) => {
  const handleChange = useCallback(
    (event: React.FocusEvent<HTMLInputElement, Element>) => onSearchChange(event.target.value),
    [onSearchChange],
  );

  return (
    <div className={classNames('mb-4 flex flex-wrap items-end gap-4', className)}>
      <UDSearchInput value={search} placeholder={searchPlaceholder} loading={isSearchLoading} onChange={handleChange} width="320px" />

      {extraFilters}

      <UDPerPage className="ml-auto" value={perPage} onChange={onPerPageChange} />
    </div>
  );
};

export default UDPagedListToolbar;
